<template>
  <div>
    <zws-login-page :propsList="propsList" v-on:loginSuccess="loginSuccess" v-on:loginFailed="loginFailed"></zws-login-page>
  </div>
</template>
<script>
import { ZWSProject } from '@/native/ZWSProject.js'
import {mapMutations} from 'vuex'
export default {
  components: { ZWSProject },
  data () {
    return {
      propsList: ''
    }
  },
  created () {
    this.propsList = ZWSProject.loginPropsList
    this.clearOrder()
  },
  methods: {
    ...mapMutations(['SET_ORDERLIST', 'SET_ORDERINFO']),
    clearOrder () {
      this.SET_ORDERLIST([])
      this.SET_ORDERINFO({})
    },
    // 登录成功
    loginSuccess (value) {
      sessionStorage.setItem('needLoginAgain', 'zlgLabel')
      localStorage.setItem('zlg_label_userinfo', JSON.stringify(value.data))
      this.$i18n.locale = value.data.language ? value.data.language : 'zh'
      localStorage.setItem('zlb_label_language', this.$i18n.locale)
      this.$router.push('/Home')
    },
    // 登录失败
    loginFailed (value) {
      console.log(value)
      if (value && value.response && value.response.status === 400) {
        this.$message.error(this.$i18n.locale === 'zh' ? '登录失败，请检查用户名或者密码是否输入有误' : 'Login failed. Please check if user name or password is entered correctly.')
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/Auth/Login.vue